'use es6';

import { Record } from 'immutable';
import { FBGeolocationTypes, Networks } from 'AdsUI/lib/Constants';
import I18n from 'I18n';
const GEOLOCATION_TEXT_BY_TYPE = {
  [FBGeolocationTypes.COUNTRY_GROUP]: countryGroup => countryGroup.name,
  [FBGeolocationTypes.COUNTRY]: country => country.name,
  [FBGeolocationTypes.REGION]: region => I18n.text('creation.targeting.placeName', {
    name: region.name,
    country: region.countryName
  }),
  [FBGeolocationTypes.CITY]: city => city.regionName ? I18n.text('creation.targeting.cityName', {
    name: city.name,
    region: city.regionName,
    country: city.countryName
  }) : I18n.text('creation.targeting.cityNameWithoutRegion', {
    name: city.name,
    country: city.countryName
  }),
  [FBGeolocationTypes.GEO_MARKET]: geoMarket => I18n.text('creation.targeting.geoMarket', {
    name: geoMarket.name,
    country: geoMarket.countryName
  })
};

const getAdWordsLocationName = location => {
  if (location.countryName && location.regionName) {
    return I18n.text('creation.targeting.cityName', {
      name: location.name,
      region: location.regionName,
      country: location.countryName
    });
  }

  if (location.countryName) {
    return I18n.text('creation.targeting.placeName', {
      name: location.name,
      country: location.countryName
    });
  }

  return location.name;
};

const GeolocationRecord = new Record({
  key: null,
  name: null,
  type: null,
  countryName: null,
  countryCode: null,
  regionName: null,
  regionId: null,
  text: null,
  network: null,

  getText() {
    if (this.network === Networks.ADWORDS) {
      return getAdWordsLocationName(this);
    }

    if (!this.type) {
      return this.name;
    }

    return GEOLOCATION_TEXT_BY_TYPE[this.type](this);
  },

  isOverlap(otherLocation) {
    switch (this.type) {
      case FBGeolocationTypes.COUNTRY:
        {
          return otherLocation.countryCode === this.key;
        }

      case FBGeolocationTypes.REGION:
        {
          return otherLocation.regionId === this.key || otherLocation.key === this.countryCode;
        }

      case FBGeolocationTypes.CITY:
        {
          if (otherLocation.type === FBGeolocationTypes.REGION && this.regionId) {
            return this.regionId === otherLocation.key;
          }

          return this.countryCode === otherLocation.key;
        }

      default:
        return false;
    }
  }

});
export default GeolocationRecord;